import { Link } from 'react-router-dom';
import { formatPrice } from '../../utils/helpers';
import { getPrimaryImage } from '../../services/imageService';
import Image from '../common/Image';
import StarRating from '../rating/StarRating';
import './ProductCard.css';

const ProductCard = ({ product }) => {
  const primaryImage = getPrimaryImage(product.images);
  const ratingCount = product.rating_count || 0;
  const ratingAverage = Number(product.rating_average) || 0;

  return (
    <Link to={`/products/${product.slug}`} className="product-card">
      <div className="product-card-image">
        <Image 
          src={primaryImage?.image_url} 
          alt={product.name}
          fallback="/placeholder-watch.jpg"
        />
        {product.is_best_seller && (
          <span className="product-badge best-seller">Best Seller</span>
        )}
        {product.is_new_arrival && (
          <span className="product-badge new-arrival">New</span>
        )}
      </div>
      <div className="product-card-info">
        <h3 className="product-card-name">{product.name}</h3>
        {/* Unrated products show nothing at all rather than an empty five-star row. */}
        {ratingCount > 0 && (
          <div className="product-card-rating">
            <StarRating
              value={ratingAverage}
              size="sm"
              label={`Rated ${ratingAverage} out of 5 from ${ratingCount} reviews`}
            />
            <span className="product-card-rating-count">({ratingCount})</span>
          </div>
        )}
        <div className="product-card-price-container">
          {product.discounted_price ? (
            <>
              <p className="product-card-price discounted">{formatPrice(product.discounted_price)}</p>
              <p className="product-card-price original">{formatPrice(product.price)}</p>
            </>
          ) : (
            <p className="product-card-price">{formatPrice(product.price)}</p>
          )}
        </div>
        {product.stock_quantity === 0 && (
          <p className="product-card-stock out-of-stock">Out of Stock</p>
        )}
      </div>
    </Link>
  );
};

export default ProductCard;
